import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  AGENT,
  BRANCH,
} from '@/components/FilterBar/constants/filtersConstants';

export default function UseShowGroupByBranch() {
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);

  return useMemo(() => {
    const selectedBranches = (selectedIds || []).filter(
      (x) => x?.filter_type === BRANCH
    );
    const selectedAgents = (selectedIds || []).filter(
      (x) => x?.filter_type === AGENT
    );

    // If filtering by branches:
    // - 1 branch => do not show
    // - >1 branch => show
    if (selectedBranches.length === 1) return false;
    if (selectedBranches.length > 1) return true;

    // If not filtering by any agent, we should show the option.
    if (selectedAgents.length === 0) return true;

    // Determine the agents' branches using selectedIds only.
    const branchIds = selectedAgents.map((a) => a?.branch_id).filter(Boolean);

    // If we can't determine branches from selectedIds, default to showing the option.
    if (branchIds.length === 0) return true;

    const uniqueBranchCount = new Set(branchIds).size;

    // Same branch => do not show. Different branches => show.
    return uniqueBranchCount !== 1;
  }, [selectedIds]);
}
